import { V_URL_API } from "../../../../utils/config";

/**
 * Servicio para obtener todas las categorías de los cursos disponibles en la base de datos.
 *
 * @returns {Promise<Response>} - Respuesta de la API con la lista de categorías.
 * @throws {Error} - Lanza un error si la petición falla.
 */
export async function getCategoriaData() {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "GET",
  };

  return await fetch(`${V_URL_API}/api/categorias`, requestOptions);
}

/**
 * Servicio para obtener todos los cursos populares que se muestran en la pagina de HOME
 *
 * @returns {Promise<Response>} - Respuesta de la API con los cursos populares.
 * @throws {Error} - Lanza un error si la petición falla.
 */
export async function getCursosPopulares() {

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "GET",
    mode: "cors", // Habilita las solicitudes CORS
  };

  return await fetch(`${V_URL_API}/api/cursos/populares`, requestOptions);
}
